import React, { useState } from 'react'
import AccessTimeIcon from '@material-ui/icons/AccessTimeRounded'
import { Checkbox, IconButton, Popover } from '@material-ui/core'

export const WaitingListLabel = ({
  label,
  rest,
  isWaitingListAllowed = false,
  isOptionOwner = false,
  inWaitingList = false,
  inWaitingListQueue = false,
  onToggleWaitingListQueue,
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  // stop propagation so the click doesn't select the parent option (select menu item, radio, checkbox);
  // the popover is portaled but React events still bubble through it to the parent
  const stopPropagation = (event) => event.stopPropagation()
  const handleClick = (event) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined
  return (
    <>
      <span>{label}</span>
      {typeof rest === 'number' && (
        <span
          style={{
            color: 'red',
            ...((!(rest !== 0 || isOptionOwner) || inWaitingList) && { opacity: '0.5' }),
          }}
        >
          {' '}
          (reste: {rest})
        </span>
      )}
      {inWaitingList && (
        <strong style={{ color: 'red' }}> (On waiting list)</strong>
      )}
      {(!inWaitingList && rest === 0 && !isOptionOwner && isWaitingListAllowed) && (
        <>
          <IconButton onClick={handleClick}>
            <AccessTimeIcon
              key={
                inWaitingListQueue
                  ? 'inWaitingListQueue'
                  : 'notInWaitingListQueue'
              }
              style={{
                color: 'red',
                backgroundColor: inWaitingListQueue ? 'lightcoral' : 'auto',
              }}
            />
          </IconButton>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            onClick={stopPropagation}
          >
            <div style={{ padding: '10px' }}>
              <div>
                Ce participant sera en file d’attente pour cette option
                <Checkbox
                  checked={inWaitingListQueue}
                  onChange={onToggleWaitingListQueue}
                />
              </div>
            </div>
          </Popover>
        </>
      )}
    </>
  )
}
